import { Expose, Type } from 'class-transformer'
import { Home as HomeIcon } from '@material-ui/icons'

import { Client } from './Client'
import { SupplyChain } from './SupplyChain'

export class User {
  static Icon = HomeIcon

  @Expose({ name: 'xid' })
  guid: string = ''

  email?: string

  @Expose({ name: 'first_name' })
  firstName?: string

  @Expose({ name: 'last_name' })
  lastName?: string

  @Expose({ name: 'type' })
  userType: string = ''

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  get name() {
    return `${this.fullName}<${this.email}>`
  }

  @Expose({ name: 'profile_image' })
  profileImage?: string

  @Type(() => Client)
  clients?: Client[]

  @Type(() => SupplyChain)
  supplyChains?: SupplyChain[]

  @Expose({ name: 'is_active' })
  isActive: boolean = true
}
